import React from 'react'
import { pushDatalayer } from '../seo/datalayer'
import { Clickable } from '../utils/clickable'
import { translate } from '../utils/translate'

export const CookiePlaceholder = ({ acceptCookie }: { acceptCookie: () => void }) => (
  <section className="cookies">
    <div className="cookies__inner">
      <div className="cookies__text">
        {translate(
          'cookies:cookiebarCookiesInlineText',
          {},
          'To be able to view this content you need to accept the cookies that come from this third party.'
        )}
      </div>

      <Clickable
        elementKind="button"
        styleKind="button"
        label={translate('cookies:cookiebarCookiesInlineButton', {}, 'Accept cookies')}
        onClick={() => {
          pushDatalayer({ category: 'video_cookies', action: 'accept', label: window.location.href })
          acceptCookie()
        }}
        className="cookies__clickable button button--small"
        hasBlob={true}
        icon={'icon-chevron-right'}
      />
    </div>
  </section>
)
